import React, { useState } from "react"
import { Card, CardBody, Collapse } from "reactstrap"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import ReportTable from "components/Common/ReportTable"
import MonitorTransactionFilter from "./filter"

const MonitorTransactionListComponent = ({
  data,
  loading,
  onSearch,
  onChangeRowNumber,
  onChangeOrdering,
  onExportBtnClick,
  onAdvancedSearchSubmit,
  exportTransaction,
  onPageClick,
  columns,
  visibleColumns,
  onToggleColumn,
}) => {
  const [filterOpen, setFilterOpen] = useState(false)

  const onAdvancedSearchHandler = result => {
    setFilterOpen(result)
  }

  return (
    <Card>
      <CardBody>
        <CustomHeaderTitle
          loading={loading}
          title={""}
          exportBtn={true}
          exportBtnLoading={exportTransaction?.loading}
          onExportBtnClick={onExportBtnClick}
          rowCount={true}
          onChangeRowNumber={onChangeRowNumber}
          orderingList={true}
          onChangeOrdering={onChangeOrdering}
          searchBox={true}
          onSearchHandler={onSearch}
          rightBtn={false}
          advnacedSearchBtn={true}
          advnacedSearchBtnTitle={"Filter"}
          onAdvancedSearch={onAdvancedSearchHandler}
          orderingOptions={[{ value: "date", name: "Transaction Date" }]}
        />
        <Collapse isOpen={filterOpen}>
          <MonitorTransactionFilter
            loading={loading}
            onAdvancedSearchSubmit={onAdvancedSearchSubmit}
            columns={columns}
            onToggleColumn={onToggleColumn}
          />
        </Collapse>

        <ReportTable
          visibleColumns={visibleColumns}
          data={data?.data}
          loading={loading}
          pagination={{ meta: data?.meta, onPageClick }}
        />
      </CardBody>
    </Card>
  )
}

export default MonitorTransactionListComponent
